import { Component, OnInit } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from '../../core/auth/auth.service';
import { UserService } from '../../core/user.service';
import * as Chart from "chart.js";
import {MatDialog, MatDialogConfig} from "@angular/material";
import { CqmnsProjectPopupComponent } from "../../_models/cqmns-project-popup/cqmns-project-popup.component";


@Component({
  selector: 'app-cqm-ns',
  templateUrl: './cqm-ns.component.html',
  styleUrls: ['./cqm-ns.component.css']
})
export class CqmNsComponent implements OnInit {

  selectedwallet = 'jira' ;
  parentMessage = "message from parent"
  projects: any;
  projectId: any;
  application: any;
  hostUrl;
  websiteName: any;
  webSites : any = [];
  webSite: any;
  youGotIDValue: any;
  bindValue: any;
  youGotName: any;
  viewId: any;
  value1: any;
  azureProfile: any;
  azureStatus: any;
  value: any;
  isoDate: any;
  NowDate: any;
  fromTime: any;
  toTime: any;
  projectName: any;
  projectList:any;
  activedashboard=false;
  analyticsSource:any;
  analyticsStatus:any;
  showLog:boolean;
  userId: any;
  constructor(private http: HttpClient, 
    private route: ActivatedRoute,
     private userService: UserService,
     private matDialog: MatDialog,
     private authService: AuthService, 
     ) { }

  ngOnInit() { 
   // this.project();
   this.authService.user() .subscribe(
    data => {});
    this.hostUrl=this.userService.getUrl();
    // this.projectId = this.route.snapshot.params["projectId"];
    this.userId = localStorage.getItem("userid");
    this.projectId = localStorage.getItem("projectId");
    if(this.projectId === 'undefined' || this.projectId === null || this.projectId === ''){
      this.project();
    }
    this.projectName = localStorage.getItem("cqm-project-name");
if(this.projectId){
  if (!this.projectName) {
    this.http
  .get(
    encodeURI(
      this.hostUrl + "/api/issue/activatedProjects/" + this.projectId
    )
  )
  .subscribe(data => {
    this.projectList = data;
    for (let i = 0; i <= this.projectList.length; i++) {
      if(this.projectList[i]){
        this.projectName = this.projectList[i].project_name;

      }
    }
  });
  }

  this.http
  .get(
    encodeURI(
      this.hostUrl + "/api/issue/analyticsSource/" + this.projectId
    )
  )
  .subscribe(data => {
    this.analyticsSource = data;
    console.log(this.analyticsSource.result)
    this.analyticsStatus = this.analyticsSource.result;
    if(this.analyticsStatus === "false")
    {
      this.showLog = true;
    }else{
      this.showLog = false;
    }
    
  });
this.http.get(encodeURI(this.hostUrl+'/api/issue/accountNameGoogleAnalytics/' + this.projectId))
.subscribe(data => {
  this.application = data;
  this.value1 = this.application[0].View_id;
});
var s = new Date();
this.NowDate = new Date(s).toISOString().split('.')[0]+"Z";
s.setMinutes(s.getMinutes() - 5);
this.isoDate = new Date(s).toISOString().split('.')[0]+"Z";
  this.fromTime = this.NowDate;
  this.toTime = this.isoDate;
  this.http
  .get(
    encodeURI(
      this.hostUrl + "/api/issue/statusdetails/" + this.projectId  + '/' + this.isoDate + '/'+this.NowDate
    )
  )
  .subscribe(data => {
    this.azureStatus =data;
    console.log(this.azureStatus,'hdjhahjjkahckjahkchachjs')
    this.value = this.azureStatus[0].id;

  });
  this.activedashboard = true;
}

  }
  onChange(value1){
   console.log('value parent',value1)
  }
  
  onChangeAzure(value){
     console.log('value parent',value)
    }
    project() {
      const dialogConfig = new MatDialogConfig();
      // dialogConfig.panelClass = "login-modalbox";
      dialogConfig.backdropClass = 'popupBackdropClass';
      dialogConfig.maxHeight = window.innerHeight - 40 + 'px' ; 
      dialogConfig.panelClass = "ns-modalbox";
      dialogConfig.disableClose = false;
      this.matDialog.open(CqmnsProjectPopupComponent, dialogConfig);

  }
}






// WEBPACK FOOTER //
// ./src/app/modules/cqm-ns/cqm-ns.component.ts